<template>
  <div
    class="c-app brand-account-background-img"
    :class="{ [$route.name.toLowerCase().split(' ').join('_')]: true, 'c-dark-theme': $store.state.darkMode  }"
  >
    <b-row class="navbarminheight">
      <b-col>
        <b-navbar toggleable="lg" type="dark" class="topnavigation" fixed="top">
          <b-navbar-brand class="pl-2">{{ $route.name }}</b-navbar-brand>
          <b-navbar-toggle target="nav_collapse" class="ml-auto" />
          <b-collapse is-nav id="nav_collapse" class="ml-auto">
            <b-navbar-nav class="ml-auto mr-3" >
              <b-nav-item @click="$store.dispatch('signoutMS')">
                <i class="fa fa fa-windows pr-2"></i>Sign Out
              </b-nav-item>
              <b-nav-item to="/signin">
                <i class="fa fa-user pr-2"></i>Sign in
              </b-nav-item>
              <!-- <b-nav-item to="/published">
                <i class="fa fa-book pr-2"></i>Published
              </b-nav-item> -->
              <!--  <b-nav-item to="/signup">
                  <i class="fa fa-user-plus pr-2"></i>Sign up
              </b-nav-item>-->
              <b-nav-item to="/reset?action=forgot">
                <i class="fa fa-key pr-2"></i>Forgot Password
              </b-nav-item>
              <b-nav-item href="https://www.travelplaces.co.uk" target="_blank">
                <i class="fa fa-external-link pr-2"></i>Travel Places
              </b-nav-item>            
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </b-col>
    </b-row>
    <!-- <CWrapper> -->
      <div class="c-body">
        <main class="c-main">
          <!-- <CContainer fluid> -->
            <zoom-center-transition :duration="300" mode="out-in">
              <router-view></router-view>
            </zoom-center-transition>
          <!-- </CContainer> -->
        </main>
        <TheFooter />
      </div>
    <!-- </CWrapper> -->
  </div>
</template>

<script>
import TheFooter from "./TheFooter";

import { ZoomCenterTransition } from "vue2-transitions";

export default {
  name: "TheOutside",
  components: {
    TheFooter,
    ZoomCenterTransition
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
